import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { Menu, MenuItem } from '@mui/material'
import Button from 'src/components/era-package/forms/Button'

// Only "HTS" exists today - keeping this as a list (not a single hardcoded action) means
// adding a second rule type later is a one-line addition here, not a rewrite.
const RULE_TYPES = [
  { key: 'HTS', label: 'HTS' },
]

const CreateRuleButton = ({ onSelectType }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)

  const handleOpen = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  const handleSelect = (typeKey) => {
    handleClose()
    onSelectType(typeKey)
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        startIcon={<FontAwesomeIcon icon={faPlus} width={12} />}
        endIcon={<FontAwesomeIcon icon={faChevronDown} width={10} />}
        title="Create a new rule"
      >
        Create
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {RULE_TYPES.map((type) => (
          <MenuItem key={type.key} onClick={() => handleSelect(type.key)}>
            {type.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default CreateRuleButton
